import { render, staticRenderFns } from "./invite-mianshi-dialog.vue?vue&type=template&id=622af959&scoped=true"
import script from "./invite-mianshi-dialog.vue?vue&type=script&lang=js"
export * from "./invite-mianshi-dialog.vue?vue&type=script&lang=js"
import style0 from "./invite-mianshi-dialog.vue?vue&type=style&index=0&id=622af959&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622af959",
  null
  
)

export default component.exports